module.exports = __webpack_public_path__ + "img/amex.9a7fdab.png";